
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyCyrPKsktJjTILHYFiKct_HWTRWGloDzAs",
  authDomain: "hotel-admin-fc2ab.firebaseapp.com",
  projectId: "hotel-admin-fc2ab",
  storageBucket: "hotel-admin-fc2ab.appspot.com",
  messagingSenderId: "826051025813",
  appId: "1:826051025813:web:1bd7af75359d003ed5349c",
  measurementId: "G-N45HEZCT1R"
};

export const app = initializeApp(firebaseConfig);
